"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TemplatePermissions {
}
exports.TemplatePermissions = TemplatePermissions;
//# sourceMappingURL=TemplatePermissions.js.map